import { createSlice } from "@reduxjs/toolkit";
import { uploadImage } from "../../apis/setting/uploadImage";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const uploadImageSlice = createSlice({
    name: 'uploadImage',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(uploadImage.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(uploadImage.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(uploadImage.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default uploadImageSlice.reducer